import * as React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import store from 'store/store';
import { LaunchDarkly } from 'utils/features/launchDarkly';
import ApolloProvider from './Apollo';
import HtmlHead from './HtmlHead';
import IntercomWrapper from './Intercom';
import ReactQueryMiddleware from './ReactQueryMiddleware';

export interface IPlainWrapper {
  children: React.ReactNode;
}

const Middleware = ({ children }: IPlainWrapper) => {
  return (
    <ReduxProvider store={store}>
      <ApolloProvider>
        <ReactQueryMiddleware>
          <HtmlHead />
          <LaunchDarkly>
            <Router>
              <IntercomWrapper>{children}</IntercomWrapper>
            </Router>
          </LaunchDarkly>
        </ReactQueryMiddleware>
      </ApolloProvider>
    </ReduxProvider>
  );
};

export default Middleware;
